import { AnyObject, isDeveloperEmail, isFeedieEmail } from '@feedyou/utils'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { FeatureAvailability } from '../../../store/features/featuresSchema'
import { getSchema } from './utils/rjsf'
import { featureAvailabilitiesSelector } from '../../../store/features/selectors'
import { useUserInfo } from '../../../store/user'
import { permissionsForcedModeController } from './permissionsForcedModeController'

type FormSchema = AnyObject

export const useSchema = (): FormSchema => {
  const { email = '' } = useUserInfo()
  const availabilities = useSelector(featureAvailabilitiesSelector)

  return useMemo(
    () => getSchema(availabilities, getAllowedSections(email)), // I <3 PRETTIER
    [email, availabilities]
  )
}

function getAllowedSections(email: string): Record<FeatureAvailability, boolean> {
  return {
    [FeatureAvailability.PUBLIC_BETA]: true,
    [FeatureAvailability.PRIVATE_BETA]:
      permissionsForcedModeController.status || isFeedieEmail(email),
    [FeatureAvailability.DEVELOPMENT]:
      permissionsForcedModeController.status || isDeveloperEmail(email),
    [FeatureAvailability.HIDDEN]:
      permissionsForcedModeController.status ||
      // Lukas asked to be opted out from seing hidden features
      (isDeveloperEmail(email) && !email?.toLowerCase().startsWith('lukas.secky'))
  }
}
